import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";

export const ArticlesGrid = ({ articles }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="media-articles-grid">
    {articles.map((a) => (
      <Link key={a.id} to={`/articles/${a.slug || a.id}`} data-testid={`media-article-${a.id}`} className="eyw-card overflow-hidden group flex flex-col">
        <div className="relative aspect-video bg-[#144F75]/10 overflow-hidden">
          {a.cover_image ? <img src={a.cover_image} alt={a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform" />
            : <div className="h-full w-full grid place-items-center text-[#144F75]"><FileText size={40} /></div>}
          <span className="absolute bottom-3 left-3 flex items-center gap-1.5 bg-white/90 rounded-full px-3 py-1 text-xs font-medium text-[#144F75]"><FileText size={13} /> Article</span>
        </div>
        <div className="p-5 flex-1 flex flex-col">
          <h3 className="text-lg text-[#1A242B]">{a.title}</h3>
          <p className="text-sm text-[#4A5D6B] mt-1 line-clamp-2 flex-1">{a.excerpt}</p>
          <span className="text-sm font-medium text-[#144F75] mt-3 inline-flex items-center gap-1">Read article <ArrowRight size={14} /></span>
        </div>
      </Link>
    ))}
  </div>
);
